export default {
  label: {
    xAxis: {
      title: 'Horário',
    },
    yAxis: {
      title: 'Respondentes',
    },
    bubble: {
      name: 'Nombre',
      value: 'Total de atividade',
      hour: 'Horário',
      opened: 'Abierto',
      answered: 'Respondido',
      waiting: 'Em Espera',
      closed: 'Fechado',
      ignored: 'Ignorado',
      percentage: 'Porcentagem p/ usuario',
      percentageGlobal: 'Porcentagem Global',
    },
  },
};
